var _style, _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPlaystore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 39",
    style: {
      enableBackground: "new 0 0 130 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.2;stroke-miterlimit:10;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:url(#SVGID_3_);}\r\n\t.st5{fill:url(#SVGID_4_);}\r\n\t.st6{opacity:0.2;enable-background:new    ;}\r\n\t.st7{opacity:0.12;enable-background:new    ;}\r\n\t.st8{opacity:0.25;fill:#FFFFFF;enable-background:new    ;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130,35.1c0,2.2-1.7,3.9-3.7,3.9H3.7C1.7,39,0,37.3,0,35.1V3.9C0,1.8,1.7,0,3.7,0h122.5c2.1,0,3.7,1.8,3.7,3.9L130,35.1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.7,10.1c0,0.8-0.2,1.4-0.7,1.9c-0.5,0.6-1.3,0.9-2.1,0.9c-0.8,0-1.5-0.3-2.1-0.9c-0.6-0.6-0.9-1.3-0.9-2.2 c0-0.9,0.3-1.6,0.9-2.2c0.6-0.6,1.3-0.9,2.1-0.9c0.4,0,0.8,0.1,1.2,0.2c0.4,0.2,0.7,0.4,0.9,0.6l-0.5,0.5c-0.4-0.5-0.9-0.7-1.6-0.7 c-0.6,0-1.1,0.2-1.6,0.6c-0.4,0.4-0.7,1-0.7,1.7c0,0.7,0.2,1.2,0.7,1.7c0.4,0.4,1,0.6,1.6,0.6c0.6,0,1.2-0.2,1.6-0.6 c0.3-0.3,0.4-0.7,0.5-1.2h-2.1V9.7h2.8C45.6,9.8,45.7,10,45.7,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.1,7.7h-2.6v1.8h2.4v0.7h-2.4V12h2.6v0.7h-3.4V7h3.4V7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.2,12.8h-0.7V7.7h-1.6V7h4v0.7h-1.6V12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.7,12.8V7h0.7v5.8H57.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.8,12.8H61V7.7h-1.6V7h4v0.7h-1.6V12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.9,12c-0.6,0.6-1.3,0.9-2.1,0.9c-0.8,0-1.6-0.3-2.1-0.9c-0.6-0.6-0.9-1.3-0.9-2.1s0.3-1.6,0.9-2.1 c0.6-0.6,1.3-0.9,2.1-0.9c0.8,0,1.5,0.3,2.1,0.9c0.6,0.6,0.9,1.3,0.9,2.1C71.7,10.7,71.5,11.4,70.9,12z M67.2,11.5 c0.4,0.4,1,0.6,1.6,0.6s1.1-0.2,1.6-0.6c0.4-0.4,0.6-1,0.6-1.7c0-0.7-0.2-1.2-0.6-1.7c-0.4-0.4-1-0.6-1.6-0.6s-1.1,0.2-1.6,0.6 c-0.4,0.4-0.6,1-0.6,1.7C66.6,10.5,66.8,11.1,67.2,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.8,12.8V7h0.9l2.8,4.5h0l0-1.1V7h0.7v5.8h-0.8L73.5,8h0l0,1.1v3.6H72.8z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.6,21.2c-2.3,0-4.1,1.7-4.1,4.1c0,2.4,1.8,4.1,4.1,4.1c2.3,0,4.1-1.7,4.1-4.1C69.7,22.9,67.9,21.2,65.6,21.2 z M65.6,27.8c-1.2,0-2.3-1-2.3-2.5c0-1.5,1.1-2.5,2.3-2.5s2.3,1,2.3,2.5C67.9,26.7,66.9,27.8,65.6,27.8z M56.6,21.2 c-2.3,0-4.1,1.7-4.1,4.1c0,2.4,1.8,4.1,4.1,4.1c2.3,0,4.1-1.7,4.1-4.1C60.8,22.9,58.9,21.2,56.6,21.2z M56.6,27.8 c-1.2,0-2.3-1-2.3-2.5c0-1.5,1.1-2.5,2.3-2.5c1.2,0,2.3,1,2.3,2.5C59,26.7,57.9,27.8,56.6,27.8z M46,22.4v1.7h4.2 c-0.1,1-0.4,1.7-0.9,2.2c-0.6,0.6-1.6,1.3-3.2,1.3c-2.6,0-4.6-2.1-4.6-4.6s2-4.6,4.6-4.6c1.4,0,2.4,0.5,3.1,1.2l1.2-1.2 c-1-1-2.4-1.8-4.4-1.8c-3.5,0-6.5,2.9-6.5,6.4c0,3.5,2.9,6.4,6.5,6.4c1.9,0,3.3-0.6,4.4-1.8c1.1-1.1,1.5-2.8,1.5-4.1 c0-0.4,0-0.8-0.1-1.1H46z M89.6,23.8c-0.3-0.9-1.4-2.6-3.5-2.6c-2.1,0-3.9,1.7-3.9,4.1c0,2.3,1.7,4.1,4.1,4.1c1.9,0,3-1.1,3.4-1.8 l-1.4-0.9c-0.5,0.7-1.1,1.1-2,1.1c-0.9,0-1.6-0.4-2-1.2l5.5-2.3L89.6,23.8z M84,25.2c0-1.6,1.2-2.4,2.1-2.4c0.7,0,1.3,0.4,1.5,0.9 L84,25.2z M79.6,29.1h1.8v-12h-1.8V29.1z M76.6,22.1L76.6,22.1c-0.5-0.5-1.2-0.9-2.2-0.9c-2,0-3.9,1.8-3.9,4.1 c0,2.3,1.9,4.1,3.9,4.1c1,0,1.8-0.4,2.2-0.9h0.1V29c0,1.6-0.8,2.4-2.2,2.4c-1.1,0-1.8-0.8-2.1-1.5l-1.6,0.7c0.4,1.1,1.6,2.4,3.6,2.4 c2.1,0,3.9-1.2,3.9-4.3v-7.4h-1.7V22.1z M74.6,27.8c-1.2,0-2.3-1-2.3-2.5c0-1.4,1-2.5,2.3-2.5c1.2,0,2.2,1.1,2.2,2.5 C76.7,26.7,75.8,27.8,74.6,27.8z M98,17.1h-4.3v12h1.8v-4.6H98c2,0,3.9-1.4,3.9-3.7S100,17.1,98,17.1z M98.1,22.9h-2.6v-4.1h2.6 c1.3,0,2.1,1.1,2.1,2.1C100.2,21.8,99.4,22.9,98.1,22.9z M109.2,21.2c-1.3,0-2.6,0.6-3.2,1.8l1.6,0.7c0.3-0.7,1-0.9,1.6-0.9 c0.9,0,1.9,0.6,1.9,1.5v0.1c-0.3-0.2-1-0.5-1.9-0.5c-1.7,0-3.5,0.9-3.5,2.7c0,1.6,1.4,2.6,3,2.6c1.2,0,1.9-0.5,2.3-1.2h0.1v0.9h1.7 v-4.6C112.8,22.4,111.2,21.2,109.2,21.2z M109,27.8c-0.6,0-1.4-0.3-1.4-1c0-0.9,1-1.3,1.9-1.3c0.8,0,1.2,0.2,1.6,0.4 C111,27,110,27.8,109,27.8z M119.2,21.4l-2.1,5.2H117l-2.1-5.2H113l3.2,7.3l-1.8,4.1h1.9l4.9-11.4H119.2z M103,29.1h1.8v-12H103 V29.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.9922,
    y1: 31.399,
    x2: 4.8314,
    y2: 15.2382,
    gradientTransform: "matrix(1 0 0 -1 0 40.0269)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    style: {
      stopColor: "#00A1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#00DFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E3FF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10,7.5C9.8,7.8,9.6,8.3,9.6,8.9v21.3c0,0.6,0.2,1.1,0.4,1.4l0.1,0.1l11.9-11.9v-0.1v-0.1L10,7.5L10,7.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.5812,
    y1: 20.5255,
    x2: 9.2804,
    y2: 20.5255,
    gradientTransform: "matrix(1 0 0 -1 0 40.0269)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FFBD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9C00"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26,23.6l-4-4v-0.1v-0.1l4-4l0.1,0.1l4.7,2.7c1.3,0.8,1.3,2,0,2.8L26,23.6L26,23.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.9073,
    y1: 18.3158,
    x2: 1.992,
    y2: -3.5995,
    gradientTransform: "matrix(1 0 0 -1 0 40.0269)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3A44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31162"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M26.1,23.6l-4.1-4.1l-12,12c0.4,0.5,1.2,0.5,2,0.1L26.1,23.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.027,
    y1: 39.6165,
    x2: 16.8131,
    y2: 29.8304,
    gradientTransform: "matrix(1 0 0 -1 0 40.0269)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M26.1,15.4L12,7.4C11.2,7,10.5,7,10,7.5l12,12L26.1,15.4z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M26,23.5l-14,7.9c-0.8,0.4-1.5,0.4-1.9,0l0,0L10,31.5l0,0l0.1,0.1l0,0c0.4,0.4,1.1,0.4,1.9,0L26,23.5L26,23.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M10,31.4c-0.3-0.3-0.4-0.8-0.4-1.4v0.1c0,0.6,0.2,1.1,0.4,1.4V31.4L10,31.4z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M30.8,20.8L26,23.5l0.1,0.1l4.7-2.7c0.7-0.4,1-0.9,1-1.4l0,0C31.8,20,31.4,20.4,30.8,20.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M12,7.6l18.8,10.7c0.6,0.3,1,0.8,1,1.2l0,0c0-0.5-0.3-1-1-1.4L12,7.4c-1.3-0.8-2.4-0.1-2.4,1.4V9 C9.6,7.5,10.7,6.8,12,7.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlaystore);
export default __webpack_public_path__ + "static/media/logo_playstore.45cb5c9335353fd9131f8dbcddc070be.svg";
export { ForwardRef as ReactComponent };